import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Seo from '../components/Seo';
import { sendContactMessage } from '../lib/api';

const CONTACT_TYPES = [
  { value: 'editorial', label: 'Editorial' },
  { value: 'escritor', label: 'Escritor/a' },
  { value: 'agencia', label: 'Agencia' },
  { value: 'marca', label: 'Marca' },
  { value: 'evento', label: 'Evento' },
  { value: 'prensa', label: 'Prensa' },
  { value: 'consulta_general', label: 'Consulta general' }
];

const INITIAL_STATE = {
  name: '',
  email: '',
  company: '',
  contactType: 'consulta_general',
  project: '',
  message: '',
  budget: '',
  consent: false
};

function Contacto() {
  const [form, setForm] = useState(INITIAL_STATE);
  const [submitting, setSubmitting] = useState(false);

  function updateField(field, value) {
    setForm((prev) => ({ ...prev, [field]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    try {
      await sendContactMessage(form);
      toast.success('Tu mensaje se ha enviado correctamente.');
      setForm(INITIAL_STATE);
    } catch (error) {
      toast.error(
        error.errors ? error.errors.join(' ') : 'No hemos podido enviar el formulario. Inténtalo de nuevo.'
      );
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="page page--narrow">
      <Seo title="Contacto" description="Contacta con Libros para Viajeros para propuestas editoriales, colaboraciones o consultas." />
      <h1>Contacto</h1>
      <p className="page__intro">hola@librosparaviajeros.es · colaboraciones@librosparaviajeros.es</p>

      <form className="contact-form" onSubmit={handleSubmit}>
        <label>
          Nombre
          <input required value={form.name} onChange={(e) => updateField('name', e.target.value)} />
        </label>
        <label>
          Email
          <input type="email" required value={form.email} onChange={(e) => updateField('email', e.target.value)} />
        </label>
        <label>
          Empresa / editorial
          <input value={form.company} onChange={(e) => updateField('company', e.target.value)} />
        </label>
        <label>
          Tipo de contacto
          <select value={form.contactType} onChange={(e) => updateField('contactType', e.target.value)}>
            {CONTACT_TYPES.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </label>
        <label>
          Libro / proyecto
          <input value={form.project} onChange={(e) => updateField('project', e.target.value)} />
        </label>
        <label>
          Mensaje
          <textarea required rows={5} value={form.message} onChange={(e) => updateField('message', e.target.value)} />
        </label>
        <label>
          Presupuesto (opcional)
          <input value={form.budget} onChange={(e) => updateField('budget', e.target.value)} />
        </label>
        <label style={{ flexDirection: 'row', alignItems: 'center', gap: '0.5rem' }}>
          <input
            type="checkbox"
            required
            checked={form.consent}
            onChange={(e) => updateField('consent', e.target.checked)}
          />
          Acepto la política de privacidad
        </label>
        <button type="submit" disabled={submitting}>
          {submitting ? 'Enviando…' : 'Enviar mensaje'}
        </button>
      </form>
    </div>
  );
}

export default Contacto;
